import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsModule } from "@ngxs/store";
import { environment } from "../environments/environment";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { SignUpState } from "./account/sign-up/sign-up.state";
import { AuthState, DEFAULT_AUTH_STATE } from "./core/auth/auth.state";
import { importProvidersFrom } from "@angular/core";
import {
  LOCAL_STORAGE_ENGINE,
  NgxsStoragePluginModule,
  SESSION_STORAGE_ENGINE,
} from "@ngxs/storage-plugin";
import { OrganizationInfoState } from "./main/organization-settings-page/profile-settings-page/organization-info.state";
import { EmailVerificationPageState } from "./account/email-verification-page/email-verification-page.state";
import { MyOpportunitiesState } from "./main/my-opportunities/shared/state";
import { OnboardingState } from "@platform-app/app/main/dashboard-page/onboarding.state";
import { AgreementBuilderState } from "@platform-app/app/agreement-builder/agreement-builder.state";
import { DashboardStatisticsState } from "@platform-app/app/main/dashboard-page/stats-panel/state/dashboard-statistics.state";
import { OnboardingWizardState } from "@platform-app/app/onboarding-wizard/shared/onboarding-wizard.state";
import { StaticDataState } from "@platform-app/app/shared/common/store/static-data/static-data.state";
import { UIPreferencesState } from "@platform-app/app/shared/common/store/preferences/ui-preferences.state";
import { A2HSState } from "@platform-app/app/shared/common/store/a2hs/a2hs.state";
import { SchoolWorkspaceSettingsState } from "@platform-app/app/shared/schools/school-workspace-settings.store";
import { PlacementsDatabaseState } from "@platform-app/app/main/placements-database/shared/store/state";
import { SchoolCoordinatorsState } from "@platform-app/app/shared/students/store/school-coordinators.state";
import { ExternshipDocumentsState } from "@platform-app/app/shared/externship-documents/externship-documents.state";
import {
  CURRENT_PLACEMENT_DATABASE_VERSION,
  DEFAULT_PLACEMENTS_DATABASE_STATE,
} from "@platform-app/app/main/placements-database/shared/store/constants";

const states = [
  AuthState,
  A2HSState,
  SignUpState,
  EmailVerificationPageState,
  OrganizationInfoState,
  OnboardingState,
  UIPreferencesState,
  MyOpportunitiesState,
  StaticDataState,
  AgreementBuilderState,
  OnboardingWizardState,
  DashboardStatisticsState,
  SchoolWorkspaceSettingsState,
  PlacementsDatabaseState,
  SchoolCoordinatorsState,
  ExternshipDocumentsState,
];

export const provideNgxs = () =>
  importProvidersFrom(
    NgxsModule.forRoot(states),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: !environment.enableNgxsDebugging,
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: !environment.enableNgxsDebugging,
    }),
    NgxsStoragePluginModule.forRoot({
      keys: [
        {
          key: AuthState,
          engine: LOCAL_STORAGE_ENGINE,
        },
        {
          key: UIPreferencesState,
          engine: LOCAL_STORAGE_ENGINE,
        },
        {
          key: A2HSState,
          engine: LOCAL_STORAGE_ENGINE,
        },
        {
          key: StaticDataState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: EmailVerificationPageState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: MyOpportunitiesState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: PlacementsDatabaseState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: OrganizationInfoState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: OnboardingState,
          engine: SESSION_STORAGE_ENGINE,
        },
        {
          key: DashboardStatisticsState,
          engine: SESSION_STORAGE_ENGINE,
        },
      ],
      migrations: [
        {
          key: "Auth",
          version: undefined!,
          migrate() {
            return DEFAULT_AUTH_STATE;
          },
        },
        {
          key: "PlacementsDatabase",
          version: CURRENT_PLACEMENT_DATABASE_VERSION,
          migrate() {
            return DEFAULT_PLACEMENTS_DATABASE_STATE;
          },
        },
      ],
    }),
  );
